import './ToasterModel.scss';
import { Toast } from 'react-bootstrap';
import { Toaster } from '../../../../interfaces/modal.interface';

type TParams = { toaster: Toaster };

function ToasterModel({ toaster }: TParams) {
  return (
     <Toast className={"toaster-default " + toaster.ClassName} show={toaster.Show === true} onClose={toaster.OnClose} delay={3000} autohide>
      <Toast.Header>
        <strong className="mr-auto">
          {toaster.Title}
        </strong>
      </Toast.Header>
      <Toast.Body>
        {toaster.Message}
      </Toast.Body>
    </Toast>
  )
}

export default ToasterModel;